// extracted by mini-css-extract-plugin
export default {"container":"SideMenu_container__6n0X8","item":"SideMenu_item__lZ6cn","selected":"SideMenu_selected__qA3Vm"};